module.exports = __webpack_public_path__ + "img/超级坦克王.97442dcb.jpg";